import { useEffect } from 'react'

const removePreloader = () => {
  const pre = document.getElementById('preloader')
  if (pre) {
    pre.style.opacity = '0'
    pre.style.transition = 'opacity 0.2s ease'

    setTimeout(() => {
      pre.remove()
      const styleTag = document.getElementById('preloader-style')
      if (styleTag) styleTag.remove()
      const scriptTag = document.getElementById('preloader-script')
      if (scriptTag) scriptTag.remove()
    }, 200)
  }
}

export const usePreloader = () => {
  useEffect(() => {
    const removeWithDelay = () => {
      setTimeout(removePreloader, 1000)
    }
    if (document.readyState === 'complete') {
      removeWithDelay()
    } else {
      window.addEventListener('load', removeWithDelay)
      return () => window.removeEventListener('load', removeWithDelay)
    }
  }, [])
}
